// import { readCookie } from '../../components/common/Cookie';

const isMsiteRefresh = (): boolean => {
  // NOTE : not checking now from release 21.0.1
  // const ab = readCookie('AB');
  // return ab === 'B';
  return true;
};

const setCookie = (key: string, value: string): void => {
  try {
    const now = new Date();
    const time = now.getTime();
    const expireTime = time + 15811200000; // 180 days
    now.setTime(expireTime);

    let domain = '';
    if (typeof location !== 'undefined') {
      const hostname = typeof window !== 'undefined' && window.location && 
        typeof window.location.hostname === 'string' ? window.location.hostname.toLowerCase() : '';

      if (hostname.includes('ajio.com')) {
        domain = '; domain=.ajio.com';
      } else if (hostname.includes('ajio.jio')) {
        domain = '; domain=.jio.com';
      } else if (hostname.includes('ajio.ril')) {
        domain = '; domain=.ril.com';
      }
    }

    // Add Secure flag for all environments except localhost
    const isLocalhost = typeof location !== 'undefined' && (location.hostname === 'localhost' || location.hostname === '127.0.0.1');
    const secureFlag = isLocalhost ? '' : '; Secure';
    document.cookie = `${key}=${value}; expires=${now.toUTCString()}; path=/${domain}${secureFlag}`;
  } catch {
    console.log(`error setting cookie ${key}`);
  }
};

export { isMsiteRefresh, setCookie };
